module.exports = __webpack_public_path__ + "img/9791155716007.4e97bca6.jpg";